export const NO_IMAGE = '/assets/default-images/questions-circular-button.png';
export const IMG_BASE = '/assets/images/80px-';
